import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TRANSACTION_SPINNER_CONFIG } from '@fmr-pr175919/fc-core-ui-lib';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { DigitalPayeeEnrollmentStatus } from '../models/digital-payee-enrollment-status.model';
import { DigitalPayeeEnrollment } from '../models/digital-payee-enrollment.model';

@Injectable({
    providedIn: 'root',
})
export class DppEnrollmentService {
    constructor(private readonly httpClient: HttpClient) {}

    enroll(enrollment: DigitalPayeeEnrollment): Observable<DigitalPayeeEnrollment> {
        const httpOptions = {
            context: new HttpContext().set(TRANSACTION_SPINNER_CONFIG, {}),
        };

        return this.httpClient.post<DigitalPayeeEnrollment>(
            environment.baseUrl + '/digitalPayee/enroll',
            enrollment,
            httpOptions
        );
    }

    getEnrollmentStatus(options: {
        npoId?: number;
        isSecondary?: boolean;
        digitalPayeeId?: number;
    }): Observable<DigitalPayeeEnrollmentStatus> {
        const secondaryParam = options.isSecondary ? '&isSecondary=true' : '';
        const queryParam = options.npoId
            ? '?npoId=' + options.npoId + secondaryParam
            : '?digitalPayeeId=' + options.digitalPayeeId;
        const url = environment.baseUrl + '/digitalPayee/enrollment' + queryParam;
        return this.httpClient.get<DigitalPayeeEnrollmentStatus>(url);
    }

    activate(
        digitalPayeeId: number,
        hasPartnership: boolean
    ): Observable<DigitalPayeeEnrollmentStatus> {
        const httpOptions = {
            context: new HttpContext().set(TRANSACTION_SPINNER_CONFIG, {}),
        };

        const activateBody = {
            hasPartnership,
        };

        return this.httpClient.post<DigitalPayeeEnrollmentStatus>(
            environment.baseUrl + '/digitalPayee/' + digitalPayeeId + '/activate',
            activateBody,
            httpOptions
        );
    }
}
